// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__QFj_P","text":"SelectPayment_text__1KkzB","title":"SelectPayment_title__3Qkuc","btn":"SelectPayment_btn__CfUgt"};